import React, { useEffect, useState } from "react";
import { updateTopicTheory, updateTopicVideo, getYoutubeEmbedUrl, fetchTopic } from "./quiz3Utils";

// Soạn/sửa nội dung lý thuyết gắn với 1 topic — hiển thị cho học sinh ở
// trang Làm bài (TQ-01) trước danh sách đề. Công khai như câu hỏi: ai
// đăng nhập cũng sửa được (chưa gắn ràng buộc chủ sở hữu riêng cho theory).
const Quiz3TopicTheory = ({ topicId }) => {
  const [theory, setTheory] = useState("");
  const [video, setVideo] = useState("");
  const [saved, setSaved] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!topicId) return;
    let cancelled = false;
    fetchTopic(topicId)
      .then((topic) => {
        if (cancelled) return;
        setTheory((topic && topic.theory) || "");
        setVideo((topic && topic.video) || "");
        setSaved(true);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [topicId]);

  if (!topicId) {
    return <p style={{ color: "#6b7280" }}>Chọn 1 chủ đề (không phải môn học gốc) để soạn lý thuyết cho nó.</p>;
  }

  const handleSave = async () => {
    setSaving(true);
    try {
      await Promise.all([
        updateTopicTheory(topicId, theory.trim()),
        updateTopicVideo(topicId, video.trim()),
      ]);
      setSaved(true);
    } finally {
      setSaving(false);
    }
  };

  const embedUrl = getYoutubeEmbedUrl(video);

  return (
    <div>
      <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 6 }}>
        Nội dung lý thuyết (hiển thị cho học sinh trước khi vào làm bài)
      </label>
      <textarea
        value={theory}
        onChange={(e) => {
          setTheory(e.target.value);
          setSaved(false);
        }}
        rows={8}
        style={{
          width: "100%",
          padding: 10,
          border: "1px solid #d1d5db",
          borderRadius: 8,
          fontSize: 14,
          boxSizing: "border-box",
          resize: "vertical",
        }}
        placeholder="Nhập nội dung lý thuyết cho chủ đề này... (Chèn ảnh: gõ 1 dòng riêng dạng ![chú thích](/duong-dan-anh.svg) hoặc ![chú thích](https://...))"
      />

      <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#374151", margin: "16px 0 6px" }}>
        Link video bài giảng (YouTube, để trống nếu không có)
      </label>
      <input
        type="text"
        value={video}
        onChange={(e) => {
          setVideo(e.target.value);
          setSaved(false);
        }}
        placeholder="https://www.youtube.com/watch?v=..."
        style={{
          width: "100%",
          padding: "8px 10px",
          border: "1px solid #d1d5db",
          borderRadius: 8,
          fontSize: 14,
          boxSizing: "border-box",
        }}
      />
      {video && !embedUrl && (
        <p style={{ color: "#dc2626", fontSize: 12, marginTop: 4 }}>Không nhận diện được link YouTube này.</p>
      )}
      {embedUrl && (
        <div style={{ marginTop: 10, aspectRatio: "16 / 9", maxWidth: 480 }}>
          <iframe
            src={embedUrl}
            title="Xem trước video bài giảng"
            style={{ width: "100%", height: "100%", border: "none", borderRadius: 8 }}
            allowFullScreen
          />
        </div>
      )}

      <div style={{ marginTop: 12, display: "flex", alignItems: "center", gap: 10 }}>
        <button
          onClick={handleSave}
          disabled={saving || saved}
          style={{
            padding: "6px 16px",
            background: saved ? "#e5e7eb" : "#2563eb",
            color: saved ? "#6b7280" : "#fff",
            border: "none",
            borderRadius: 8,
            cursor: saved ? "default" : "pointer",
            fontWeight: 600,
          }}
        >
          {saving ? "Đang lưu..." : saved ? "Đã lưu" : "Lưu"}
        </button>
      </div>
    </div>
  );
};

export default Quiz3TopicTheory;
